import { useEffect, useRef } from 'react';

export default function Products() {
  const sectionRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('animate-fade-up');
          }
        });
      },
      { threshold: 0.2 }
    );

    if (sectionRef.current) {
      const elements = sectionRef.current.querySelectorAll('.fade-element');
      elements.forEach((el) => observer.observe(el));
    }

    return () => observer.disconnect();
  }, []);

  return (
    <section id="products" ref={sectionRef} className="py-32 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-20 fade-element opacity-0">
          <h2 className="text-5xl font-bold text-gray-900 mb-4">Our Products</h2>
          <p className="text-lg text-gray-600 font-light">Designed to enhance your mobile experience</p>
        </div>

        <div className="grid md:grid-cols-2 gap-12">
          <div className="fade-element opacity-0 group cursor-pointer transition-all duration-300 hover:scale-105">
            <div className="bg-gray-50 rounded-3xl overflow-hidden shadow-lg hover:shadow-2xl transition-shadow duration-300">
              <div className="relative h-80 w-full overflow-hidden">
                <img
                  src="https://public.readdy.ai/ai/img_res/08cfd5fc5510cbcdbbe7b2975a86319f.jpg"
                  alt="VPN App Interface"
                  className="w-full h-full object-cover object-top"
                />
                <div className="absolute inset-0 bg-gradient-to-b from-transparent via-transparent to-white"></div>
              </div>
              
              <div className="bg-white p-8">
                <div className="flex items-center mb-4">
                  <div className="w-12 h-12 flex items-center justify-center bg-teal-500 rounded-xl mr-4">
                    <i className="ri-shield-check-line text-2xl text-white"></i>
                  </div>
                  <h3 className="text-3xl font-bold text-gray-900">VPN</h3>
                </div>
                
                <ul className="space-y-3 text-gray-700">
                  <li className="flex items-center text-base">
                    <span className="text-teal-500 mr-3 text-xl">•</span>
                    Secure Connection
                  </li>
                  <li className="flex items-center text-base">
                    <span className="text-teal-500 mr-3 text-xl">•</span>
                    Global Servers
                  </li>
                  <li className="flex items-center text-base">
                    <span className="text-teal-500 mr-3 text-xl">•</span>
                    Privacy Protection
                  </li>
                  <li className="flex items-center text-base">
                    <span className="text-teal-500 mr-3 text-xl">•</span>
                    Fast & Reliable
                  </li>
                </ul>
              </div>
            </div>
          </div>

          <div className="fade-element opacity-0 group cursor-pointer transition-all duration-300 hover:scale-105" style={{ animationDelay: '0.2s' }}>
            <div className="bg-gray-50 rounded-3xl overflow-hidden shadow-lg hover:shadow-2xl transition-shadow duration-300">
              <div className="relative h-80 w-full overflow-hidden">
                <img
                  src="https://readdy.ai/api/search-image?query=modern%20iOS%20Cleaner%20application%20interface%20displaying%20storage%20optimization%20with%20circular%20progress%20charts%20and%20file%20management%20on%20iPhone%20screen%20with%20clean%20green%20gradient%20background%20and%20minimalist%20design%20professional%20app%20screenshot&width=600&height=800&seq=cleaner-product-001&orientation=portrait"
                  alt="Cleaner App Interface"
                  className="w-full h-full object-cover object-top"
                />
                <div className="absolute inset-0 bg-gradient-to-b from-transparent via-transparent to-white"></div>
              </div>
              
              <div className="bg-white p-8">
                <div className="flex items-center mb-4">
                  <div className="w-12 h-12 flex items-center justify-center bg-orange-500 rounded-xl mr-4">
                    <i className="ri-brush-line text-2xl text-white"></i>
                  </div>
                  <h3 className="text-3xl font-bold text-gray-900">Cleaner</h3>
                </div>
                
                <ul className="space-y-3 text-gray-700">
                  <li className="flex items-center text-base">
                    <span className="text-orange-500 mr-3 text-xl">•</span>
                    Storage Optimization
                  </li>
                  <li className="flex items-center text-base">
                    <span className="text-orange-500 mr-3 text-xl">•</span>
                    Cache Management
                  </li>
                  <li className="flex items-center text-base">
                    <span className="text-orange-500 mr-3 text-xl">•</span>
                    Performance Boost
                  </li>
                  <li className="flex items-center text-base">
                    <span className="text-orange-500 mr-3 text-xl">•</span>
                    Smart Cleaning
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}